import React from 'react';
import { Box, Button, Typography } from '@mui/material';

import { AdminLegendVariant, ProfessionalReplacementTypes } from '@pharmaplan/common';
import styles from './styles';
import legendStyles from '../../AdminLegend/styles';
import strings from '../../../../../localization';
import useAdminLegendNavigation from '../../../../../hooks/AdminLegend/useAdminLegendNavigation';

export interface IAdminBookedLegendItem {
  labelKey: 'pharm' | 'tech';
  replacementType: ProfessionalReplacementTypes;
  totalHrs: number;
  totalCount: number;
  isRow: boolean;
}

const { booked } = AdminLegendVariant;

const AdminBookedLegendItem = ({
  labelKey,
  replacementType,
  totalHrs,
  totalCount,
  isRow,
}: IAdminBookedLegendItem) => {
  const { handleNavigateToReport } = useAdminLegendNavigation();

  const handleClick = () => {
    handleNavigateToReport(booked, replacementType);
  };

  return (
    <Box
      component={Button}
      variant="text"
      onClick={handleClick}
      sx={[styles.container, legendStyles.container(booked)]}
    >
      <Box sx={styles.textContainer}>
        <Typography
          noWrap
          sx={[legendStyles.legendTitle, isRow && legendStyles.rowLegendText]}
        >
          {strings[labelKey]}
        </Typography>
        <Box
          sx={[
            legendStyles.legendTotalHrs,
            isRow && legendStyles.rowLegendText,
            isRow && styles.rowTotalHrs,
            legendStyles.totalHrsCountColor(booked),
          ]}
        >
          {strings.formatString(strings.hoursWorked, Math.trunc(totalHrs))}
        </Box>
      </Box>
      <Box
        sx={[
          legendStyles.legendTotalCount,
          legendStyles.rowLegendTotalCount,
          legendStyles.totalHrsCountColor(booked),
        ]}
      >
        {totalCount}
      </Box>
    </Box>
  );
};

export default AdminBookedLegendItem;
